import { createFileRoute } from "@tanstack/react-router";
import FranklinSofi from "@/pages/site/FranklinSofi";

export const Route = createFileRoute("/about/franklin-sofi")({
  component: () => <FranklinSofi />,
});
